import {Link} from "react-router-dom";

import './Lizard.css';
import "../Common.css"

import useScript from '../useScript';

function Lizard()
{
    useScript('../js/lizard.js');
    //useScript('../js/mosaic2.js');

    return (
        <div className="top-buffer">
            <p>Lizard</p>
            <div id="lizardMosaic"></div>
            <Link to="/Mosaics" className="logo"></Link>
        </div>

    )
}

export default Lizard;